export default __webpack_public_path__ + "static/media/chrome-icon.16bea017.png";